import { combineReducers } from 'redux';
import {
  TOGGLE_ANVENDELSE_FILTER,
  TOGGLE_MAX_HOJDE_FILTER,
  TOGGLE_MAX_BYGPCT_FILTER,
  TOGGLE_PLANENS_ALDER_FILTER,
  HOVER_SEARCH_RESULT,
  RESET_FILTERS,
  TOGGLE_ANVGEN,
  SET_PLANENS_ALDER_FILTER,
  SET_BYGOMFANG_FILTER,
  SET_ETAGER_BYGGEHOJDE_FILTER,
  SET_ACTIVE_STYLE,
  CLICKED_BYGGEFELT,
  CLICKED_DELOMRAADE,
  SET_TOGGLED_ANVSPECS,
  TRIGGER_HISTORISKE_LOKALPLANER,
} from './actions';
import { anvgen } from '../components/Map/util/koder';
import produce from 'immer';
import {
  IStyleState,
  activeStyle,
  IFiltersState,
  ILokalplanState,
  IFilterToggleState,
  IClickedPlanState,
  IEtagerByggehojdeFilter,
  EtagerByggeHojdeFilter,
  IBygOmfangFilter,
  BygOmfangFilter,
} from './interfaces/state';
import {
  IFilterAction,
  ILokalplanAction,
  IFilterToggleAction,
} from './interfaces/actions';

function filterToggled(
  state: IFilterToggleState = {
    anvendelse: true,
    maxBygpct: true,
    maxHojde: true,
    planensAlder: true,
  },
  action: IFilterToggleAction
): IFilterToggleState {
  switch (action.type) {
    case TOGGLE_ANVENDELSE_FILTER:
      return { ...state, anvendelse: action.toggled };
    case TOGGLE_MAX_BYGPCT_FILTER:
      return { ...state, maxBygpct: action.toggled };
    case TOGGLE_MAX_HOJDE_FILTER:
      return { ...state, maxHojde: action.toggled };
    case TOGGLE_PLANENS_ALDER_FILTER:
      return { ...state, planensAlder: action.toggled };

    default:
      return state;
  }
}
function searchResult(state = { hovered: -1 }, action) {
  switch (action.type) {
    case HOVER_SEARCH_RESULT:
      return { hovered: action.planid };

    default:
      return state;
  }
}

function lokalplaner(
  state: ILokalplanState = {
    triggerHistoriskeLokalplaner: false,
  },
  action: ILokalplanAction
): ILokalplanState {
  switch (action.type) {
    case TRIGGER_HISTORISKE_LOKALPLANER:
      return {
        ...state,
        triggerHistoriskeLokalplaner: action.triggerHistoriskeLokalplaner,
      };
    default:
      return state;
  }
}

export const defaultAnvgenFilter = anvgen.map(a => a.kode);
export const defaultAnvspecFilter = [];
export const defaultPlanAlderFilter = [1970, new Date().getFullYear()];
export const defaultBygOmfangFilter: IBygOmfangFilter = {
  filter: [0, 100],
  selectedFilter: BygOmfangFilter.bebyggelsesProcent,
};
export const defaultEtagerByggeHojdeFilter: IEtagerByggehojdeFilter = {
  filter: [1, 100],
  selectedFilter: EtagerByggeHojdeFilter.byggeHojde,
};

function filters(
  state: IFiltersState = {
    generelAnvendelse: defaultAnvgenFilter,
    specifikAnvendelse: defaultAnvspecFilter,
    planensAlder: defaultPlanAlderFilter,
    bygOmfang: defaultBygOmfangFilter,
    etagerByggeHojde: defaultEtagerByggeHojdeFilter,
  },
  action: IFilterAction
): IFiltersState {
  switch (action.type) {
    case RESET_FILTERS:
      return {
        generelAnvendelse: defaultAnvgenFilter,
        specifikAnvendelse: defaultAnvspecFilter,
        planensAlder: defaultPlanAlderFilter,
        bygOmfang: defaultBygOmfangFilter,
        etagerByggeHojde: defaultEtagerByggeHojdeFilter,
      };
    case TOGGLE_ANVGEN:
      const { kode } = action;
      if (state.generelAnvendelse.indexOf(kode) > -1) {
        return {
          ...state,
          generelAnvendelse: produce(state.generelAnvendelse, draft => {
            draft = draft.filter(d => d !== kode);
            return draft;
          }),
        };
      } else {
        return {
          ...state,
          generelAnvendelse: produce(state.generelAnvendelse, draft => {
            draft.push(kode);
          }),
        };
      }
    case SET_TOGGLED_ANVSPECS:
      const { anvspecs } = action;
      return {
        ...state,
        specifikAnvendelse: anvspecs,
      };
    case SET_PLANENS_ALDER_FILTER:
      const { planAlderFilter } = action;
      return {
        ...state,
        planensAlder: planAlderFilter,
      };
    case SET_BYGOMFANG_FILTER:
      const { bygOmfangFilter } = action;
      return {
        ...state,
        bygOmfang: bygOmfangFilter,
      };
    case SET_ETAGER_BYGGEHOJDE_FILTER:
      const { etagerByggeHojdeFilter } = action;
      return {
        ...state,
        etagerByggeHojde: etagerByggeHojdeFilter,
      };

    default:
      return state;
  }
}

function style(
  state: IStyleState = { activeStyle: activeStyle.generelAnvendelse },
  action
) {
  switch (action.type) {
    case SET_ACTIVE_STYLE:
      const { activeStyle } = action;
      return { ...state, activeStyle };

    default:
      return state;
  }
}

function clickedPlan(
  state: IClickedPlanState = { byggefelt: 0, delomraade: 0 },
  action
) {
  const { id } = action;
  switch (action.type) {
    case CLICKED_BYGGEFELT:
      return { ...state, byggefelt: id };
    case CLICKED_DELOMRAADE:
      return { ...state, delomraade: id };

    default:
      return state;
  }
}

export default combineReducers({
  filterToggled,
  searchResult,
  lokalplaner,
  filters,
  style,
  clickedPlan,
});
